import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";
import { useFavorites } from "@/hooks/useFavorites";

interface MovieGridProps {
  movies: Movie[];
  emptyText?: string;
  className?: string;
}

export default function MovieGrid({
  movies,
  emptyText = "暂无相关影视内容",
  className = "",
}: MovieGridProps) {
  const { isFavorite, toggleFavorite } = useFavorites();

  if (movies.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-background-300 bg-background-50 py-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-emotion-unhappy-line text-2xl" />
        </span>
        <p className="mt-4 text-sm text-foreground-500">{emptyText}</p>
      </div>
    );
  }

  return (
    <div
      className={`grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 ${className}`}
    >
      {movies.map((movie) => (
        <MovieCard
          key={movie.id}
          movie={movie}
          isFavorite={isFavorite(movie.id)}
          onToggleFavorite={toggleFavorite}
        />
      ))}
    </div>
  );
}